import { ContentBlock, EditorState } from 'draft-js';
import entityAtChar from './entityAtChar';
import { FollowupData } from '../types';

export interface FollowupEntityState {
  exists: boolean;
  offset: number;
  endIndex: number;
  key: string;
  data: FollowupData;
  blockKey: string;
}

export default function detectFollowupEntity(
  editorState: EditorState,
  onlyCheckFocusedBlock = false,
): [ContentBlock, FollowupEntityState] {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const focusedBlock = contentState.getBlockForKey(selection.getFocusKey());
  let contentBlocks = contentState.getBlocksAsArray();

  if (onlyCheckFocusedBlock) {
    contentBlocks = [focusedBlock];
  }

  const followupEntityState = contentBlocks.reduce(
    (state, block) => {
      if (state.exists) {
        return state;
      } else {
        let { key, data, offset, endIndex, exists, blockKey } = state;

        block.findEntityRanges(
          (char) => {
            const { isFollowupEntity, entityKey, entity } = entityAtChar(char, contentState);

            if (isFollowupEntity) {
              key = entityKey;
              data = entity.getData();
              blockKey = block.getKey();
            }

            return isFollowupEntity;
          },
          (begin, end) => {
            exists = true;
            if (offset == -1) {
              offset = begin;
              endIndex = end;
            }
          },
        );

        return { key, data, offset, endIndex, exists, blockKey };
      }
    },
    {
      exists: false,
      offset: -1,
      endIndex: -1,
      key: null,
      data: null,
      blockKey: null,
    },
  );

  return [focusedBlock, followupEntityState];
}
